<div *ngIf="voucher; else loading" class="max-w-4xl mx-auto p-6">
  <h2 class="text-2xl font-bold text-white bg-black p-3 rounded-lg text-center mb-6 shadow-lg">
    🎟️ Voucher Details
  </h2>

  <div class="overflow-hidden rounded-lg shadow-xl bg-gradient-to-r from-gray-900 to-gray-700">
    <table class="w-full text-sm text-left text-white">
      <thead class="text-xs uppercase bg-cyan-600 text-white">
        <tr>
          <th scope="col" class="px-6 py-3">Field</th>
          <th scope="col" class="px-6 py-3">Value</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-600">
        <tr>
          <th scope="row" class="px-6 py-4 font-medium text-white">Creator_Id</th>
          <td class="px-6 py-4">{{ voucher.id }}</td>
        </tr>
        <tr>
          <th scope="row" class="px-6 py-4 font-medium text-white">Name</th>
          <td class="px-6 py-4">{{ voucher.name }}</td>
        </tr>
        <tr>
          <th scope="row" class="px-6 py-4 font-medium text-white">Description</th>
          <td class="px-6 py-4">{{ voucher.description }}</td>
        </tr>
        <tr>
          <th scope="row" class="px-6 py-4 font-medium text-white">Code</th>
          <td class="px-6 py-4 font-mono font-bold text-lg text-cyan-400">{{ voucher.code }}</td>
        </tr>
        <tr>
          <th scope="row" class="px-6 py-4 font-medium text-white">Status</th>
          <td class="px-6 py-4">
            <span class="px-3 py-1 rounded-lg text-white text-xs font-bold"
              [ngClass]="{'bg-green-600': voucher.status === 'active', 'bg-red-600': voucher.status === 'expired'}">
              {{ voucher.status }}
            </span>
          </td>
        </tr>
        <tr class="bg-gray-800">
          <th scope="row" class="px-6 py-4 font-medium text-white">Discount Percentage</th>
          <td class="px-6 py-4 font-semibold text-lg text-cyan-300">{{ voucher.discount_percentage }}%</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Back Button -->
  <div class="mt-6 flex justify-center">
    <button (click)="navigateToVouchers()"
      class="px-6 py-2 text-white bg-cyan-600 hover:bg-cyan-700 rounded-lg shadow-lg transition transform hover:scale-105">
      ⬅ Back to Vouchers
    </button>
  </div>
</div>

<!-- Loading State -->
<ng-template #loading>
  <div class="text-center text-cyan-400 font-semibold text-lg mt-6">
    ⏳ Loading voucher details...
  </div>
</ng-template>
